/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ChecklistChecklistidItems202,
  PostApiV1ChecklistChecklistidItems400,
  PostApiV1ChecklistChecklistidItems401,
  PostApiV1ChecklistChecklistidItems404,
  PostApiV1ChecklistChecklistidItems500,
  PostApiV1ChecklistChecklistidItemsMutationRequest,
  PostApiV1ChecklistChecklistidItemsMutationResponse,
  PostApiV1ChecklistChecklistidItemsPathParams,
} from "../../types/checkListItensController/PostApiV1ChecklistChecklistidItems.ts";
import { checkListItemViewModelSchema } from "../checkListItemViewModelSchema.ts";
import { createCheckListItemRequestViewModelSchema } from "../createCheckListItemRequestViewModelSchema.ts";

export const postApiV1ChecklistChecklistidItemsPathParamsSchema = z.object({
  checkListId: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1ChecklistChecklistidItemsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1ChecklistChecklistidItems202Schema = z.lazy(
  () => checkListItemViewModelSchema,
) as unknown as ToZod<PostApiV1ChecklistChecklistidItems202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1ChecklistChecklistidItems400Schema =
  z.any() as unknown as ToZod<PostApiV1ChecklistChecklistidItems400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ChecklistChecklistidItems401Schema =
  z.any() as unknown as ToZod<PostApiV1ChecklistChecklistidItems401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1ChecklistChecklistidItems404Schema =
  z.any() as unknown as ToZod<PostApiV1ChecklistChecklistidItems404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1ChecklistChecklistidItems500Schema =
  z.any() as unknown as ToZod<PostApiV1ChecklistChecklistidItems500>;

export const postApiV1ChecklistChecklistidItemsMutationRequestSchema = z.lazy(
  () => createCheckListItemRequestViewModelSchema,
) as unknown as ToZod<PostApiV1ChecklistChecklistidItemsMutationRequest>;

export const postApiV1ChecklistChecklistidItemsMutationResponseSchema = z.lazy(
  () => postApiV1ChecklistChecklistidItems202Schema,
) as unknown as ToZod<PostApiV1ChecklistChecklistidItemsMutationResponse>;
